'use client';

import { useEffect } from 'react';

/**
 * Registra o service worker, que e o que torna o painel instalavel.
 *
 * Só em produção: no modo de desenvolvimento ele serviria arquivos em cache
 * por cima do recarregamento a quente e faria parecer que a alteração não
 * pegou.
 */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (!('serviceWorker' in navigator)) return;

    const registrar = () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {
        // Navegador sem suporte ou sem HTTPS: o painel funciona igual, apenas
        // não fica instalável. Nada a fazer além de seguir.
      });
    };

    // Depois do carregamento: registrar durante a abertura disputa banda com
    // o que a pessoa veio ver.
    if (document.readyState === 'complete') registrar();
    else window.addEventListener('load', registrar, { once: true });

    return () => window.removeEventListener('load', registrar);
  }, []);

  return null;
}
